<script>
  import Button from '@leaflink/stash/Button.vue';
  import Icon from '@leaflink/stash/Icon.vue';

  import BatchDetails from '@/components/BatchDetails';
  import ExpandLegacy from '@/components/LLExpand/LLExpand.vue';
  import { decimal } from '@/utils/i18n';

  export default {
    name: 'BatchInformation',

    components: {
      BatchDetails,
      Button,
      Icon,
      ExpandLegacy,
    },

    props: {
      batch: {
        type: Object,
        required: true,
      },
      isOpen: Boolean,
    },

    data() {
      return {
        isExpanded: this.isOpen,
      };
    },

    methods: {
      decimal,

      toggleExpand() {
        this.isExpanded = !this.isExpanded;
      },
    },
  };
</script>

<template>
  <div class="border rounded ll-mb-2">
    <header class="flex align-middle cursor-pointer" @click="toggleExpand">
      <Button class="color-ice-900 ll-mr-1" icon>
        <Icon :class="[isExpanded ? 'rotate-270' : 'rotate-180']" name="chevron-left" />
      </Button>
      <h3 class="flex-1">{{ batch.productionBatchNumber }}</h3>
    </header>
    <ExpandLegacy :open="isExpanded">
      <div class="ll-pa-3">
        <BatchDetails
          :batch-results="batch.result"
          :cannabinoid-unit="batch.cannabinoidUnit"
          :documents="batch.documents"
        />
      </div>
    </ExpandLegacy>
  </div>
</template>
